module.exports = __webpack_public_path__ + "static/portfolio-056a346a9884709ea390ef6acac08234.jpg";